import { IconSpecGlyph } from '@shared/components/IconGlyph.js';
import type { IsCustomLayerTechnologiesDef } from '@shared/mapDefinitions.js';
import type { ReactElement, ReactNode } from 'react';
import { FaServer, FaTh } from 'react-icons/fa';
import { MdOfflinePin } from 'react-icons/md';
import { TbStack2, TbVector } from 'react-icons/tb';

export type CustomMapKind =
  | IsCustomLayerTechnologiesDef['technology']
  | 'preset';

export const CUSTOM_MAP_ICONS: Record<CustomMapKind, ReactElement> = {
  tile: <FaTh />,
  maplibre: <TbVector />,
  wms: <FaServer />,
  preset: <TbStack2 />,
};

type GlyphKind = CustomMapKind | 'cached';

const FALLBACKS: Record<GlyphKind, ReactElement> = {
  ...CUSTOM_MAP_ICONS,
  cached: <MdOfflinePin />,
};

/** What a custom or cached map falls back on; a built-in layer has no kind. */
export function customMapKind(def: {
  technology?: string;
  sourceType?: string;
}): GlyphKind | undefined {
  if (def.sourceType !== undefined) {
    return 'cached';
  }

  return def.technology && Object.hasOwn(CUSTOM_MAP_ICONS, def.technology)
    ? (def.technology as CustomMapKind)
    : undefined;
}

/** A custom or cached map's or a preset's picked icon, else its kind's. */
export function CustomMapGlyph({
  spec,
  kind,
}: {
  spec?: string;
  kind?: GlyphKind;
}): ReactNode {
  return <IconSpecGlyph spec={spec} fallback={kind ? FALLBACKS[kind] : null} />;
}
